import { render, staticRenderFns } from "./BreakBox.vue?vue&type=template&id=6ee45f60&scoped=true&"
import script from "./BreakBox.vue?vue&type=script&lang=ts&"
export * from "./BreakBox.vue?vue&type=script&lang=ts&"
import style0 from "./BreakBox.vue?vue&type=style&index=0&id=6ee45f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee45f60",
  null
  
)

export default component.exports